var React = require('react');

function IconLinkedinWhiteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Caminho_224","data-name":"Caminho 224","d":"M96.774,136.633v32.186h32.188V136.633Zm9.409,27.631h-4.035V147.95h4.035Zm0-18.259h-4.035v-3.938h4.035ZM123.8,164.264h-4.077v-9.922a4.879,4.879,0,0,0-.318-1.977,2.213,2.213,0,0,0-2.218-1.258,2.744,2.744,0,0,0-2.757,1.84,6.759,6.759,0,0,0-.39,2.485v8.831h-3.979V147.98h3.854v2.381a7.126,7.126,0,0,1,1.446-1.812,4.789,4.789,0,0,1,3.1-.986,5.59,5.59,0,0,1,3.845,1.323q1.493,1.326,1.494,4.395Z","transform":"translate(-96.774 -136.633)","fill":"#fff"}));
}

IconLinkedinWhiteInline.defaultProps = {"width":"32.188","height":"32.186","viewBox":"0 0 32.188 32.186"};

module.exports = IconLinkedinWhiteInline;

IconLinkedinWhiteInline.default = IconLinkedinWhiteInline;
